import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Nav } from "./components/Nav";
import { SmoothScroll } from "./components/SmoothScroll";
import { RequireAuth } from "./components/Guards";
import { AgeGate } from "./components/AgeGate";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Join from "./pages/Join";
import Feed from "./pages/Feed";
import Messages from "./pages/Messages";
import Studio from "./pages/Studio";
import Billing from "./pages/Billing";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/join" element={<RequireAuth><Join /></RequireAuth>} />
        <Route path="/feed" element={<RequireAuth tier><Feed /></RequireAuth>} />
        <Route path="/messages" element={<RequireAuth tier><Messages /></RequireAuth>} />
        <Route path="/billing" element={<RequireAuth tier><Billing /></RequireAuth>} />
        <Route path="/studio" element={<RequireAuth admin><Studio /></RequireAuth>} />
        <Route path="/payment/success" element={<RequireAuth><PaymentSuccess /></RequireAuth>} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App film-grain">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll />
          <AgeGate><AppRouter /></AgeGate>
          <Toaster theme="light" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
